/**
 * LoadingSpinner - Reusable loading indicator
 * Can be used anywhere to show loading state
 */

import React from 'react';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  color?: string;
  text?: string;
  fullScreen?: boolean;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  color = 'blue',
  text,
  fullScreen = false,
  className = ''
}) => {
  const sizeConfig = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const colorClasses = {
    blue: 'border-blue-600',
    gray: 'border-gray-600',
    white: 'border-white',
    green: 'border-green-600',
    red: 'border-red-600'
  };

  const spinnerSize = sizeConfig[size];
  const spinnerColor = colorClasses[color as keyof typeof colorClasses] || 'border-blue-600';

  const spinner = (
    <div className={`${fullScreen ? 'flex flex-col items-center justify-center' : ''} ${className}`}>
      <div className={`
        ${spinnerSize}
        border-4
        border-gray-200
        ${spinnerColor}
        border-t-transparent
        rounded-full
        animate-spin
      `} />
      {text && (
        <p className={`mt-3 text-${size === 'sm' ? 'xs' : size === 'md' ? 'sm' : 'base'} text-gray-600`}>
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-75 flex items-center justify-center z-50">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner;